import ValidationInterface from "@/plans/common/validation-interface";
import { bizPlusCategories, eduPlusCategories, proPlusCategories } from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    //require unlimited plans
    return [this.current("ZPI").require(["ZVU", "ZUU", "ZAU", "ZJU", "ZSU", "ZINU", ...proPlusCategories, ...bizPlusCategories, ...eduPlusCategories], { billingCycleEqual: true, licenseMatch: false })];
  }

  async conflicts() {
    return this.current(["ZPI"]).conflict(["ZPI"]);
  }
}
